import { createFileRoute } from "@tanstack/react-router";
import CobDashboard from "@/modules/reports/pages/cob-dashboard";

export const Route = createFileRoute(
  "/(auth)/_headed/reports/_layout/change-of-broker"
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <CobDashboard />;
}
